import { createSelector, createFeatureSelector } from '@ngrx/store';

import { CropAidState } from '../crop-aid.model';

export const selectCropAidState = createFeatureSelector<CropAidState>('cropAid');

export const selectCropAids = createSelector(selectCropAidState, (state) => state?.cropAids ?? []);

export const selectCropAidFertilizers = createSelector(selectCropAids, (cropAids) =>
  cropAids.filter(({ isFertilizer }) => isFertilizer),
);
